import React from 'react'
import { withRouter } from 'react-router'
import { view } from 'react-easy-state'
// import { isMobile } from 'react-device-detect'
// import { Icon, Button } from 'antd'

import QuestionnaireView from 'components/pages/students/questionnaires/show/QuestionnaireView'

class QuestionnaireDetails extends React.Component {

  goBack = () => {
    const { chapterId } = this.props.match.params
    this.props.history.push(`/chapters/${chapterId}`)
  }

  // toggleQuestionnaireList = () => {
  //   const questionnaireListSider = document.getElementById('questionnaireListSider')
  //   questionnaireListSider.classList.toggle('active')
  // }

  // goToSettingsPage = () => {
  //   this.props.history.push('/settings')
  // }

  // // TODO: This needs to be fixed
  // goToNextQuestionnaire = (questionnaireId) => {
  //   const { chapterId } = this.props.match.params
  //   this.props.history.push(`/chapters/${chapterId}/questionnaires/${questionnaireId}`)
  // }

  // renderHeader() {
  //   if (isMobile) {
  //     return (
  //       <React.Fragment>
  //         <div className="left-menu">
  //           <Button type="link" onClick={this.goBack}><Icon type="arrow-left" /></Button>
  //           <Button type="link" onClick={this.toggleQuestionnaireList}><Icon type="unordered-list" /></Button>
  //           <Button type="link" onClick={this.goToSettingsPage}><Icon type="setting" /></Button>
  //         </div>
  //         <div className="right-menu">
  //           <Button type="link" onClick={this.goToNextQuestionnaire}><Icon type="arrow-right" /></Button>
  //         </div>
  //       </React.Fragment>
  //     )
  //   }

  //   return <div>Complete and continue <Icon type="arrow-right" /></div>
  // }

  render() {

    return (
      <div className="lecture-view">
        {/* <div className="header">
          {this.renderHeader()}
        </div> */}
        <div className="lecture-content" style={{ textAlign: 'center' }}>
          <QuestionnaireView />
        </div>
      </div>
    )
  }
}

export default withRouter(view(QuestionnaireDetails))
